import React, { createContext, useContext } from "react";

const ScopedDataLoadContext = createContext(null);
export const ScopedDataLoadProvider = ScopedDataLoadContext.Provider;
export const INITIAL_SCOPED_LOADING = Object.freeze({ status:"loading",failures:0,lastSuccessAt:null });
export const useScopedDataLoadState = () => useContext(ScopedDataLoadContext);
export const SCOPED_LOAD_FAILURE = "Não foi possível carregar os dados. Tente novamente.";
export function ScopedLeadEmptyLabel({ fallback }) {
  const state = useScopedDataLoadState();
  if (!state || state.status === "ready") return fallback;
  return state.status === "retrying" ? SCOPED_LOAD_FAILURE : "Carregando leads…";
}
export function ScopedLeadsUnavailable() {
  return <section role="status" aria-label="Carregamento de leads" style={{
    padding:"24px 16px",border:"1px solid #E8E1D3",borderRadius:12,
  }}>
    <h2 style={{ margin:"0 0 12px",fontSize:20 }}>Leads</h2>
    <ScopedLeadEmptyLabel fallback="Carregando leads…" />
  </section>;
}

export function OwnerLoadDiagnostics({ user, state, pushStatus }) {
  if (Number(user?.id)!==40 || user?.role!=="superadmin" || user?.authKind==="studio") return null;
  return <details style={{ marginBottom:12, fontSize:12, overflowWrap:"anywhere" }}>
    <summary>Diagnóstico técnico</summary>
    <div>Estado: {state?.status || "sem leitura"} · Tentativas com falha: {state?.failures || 0}</div>
    {state?.error && <div>Motivo: {state.error}</div>}
    {state?.nextDelayMs > 0 && <div>Próxima tentativa: {state.nextDelayMs / 1000}s</div>}
    {pushStatus && <div>Notificações: {pushStatus.permission} · Service worker: {pushStatus.serviceWorkerActive?"ativo":"inativo"} · Assinatura: {pushStatus.serverSaved?"confirmada":"não confirmada"}</div>}
  </details>;
}

export default function ScopedDataLoadNotice({ state, onRetry }) {
  if (!state || state.status === "ready"
    || (state.status === "loading" && !state.failures)) return null;
  return (
    <section role="status" aria-label="Carregamento dos dados do CRM" style={{
      background: "#F8FAFC", border: "1px solid #E2E8F0", borderRadius: 9,
      padding: "8px 12px", marginBottom: 14, color: "#64748B", fontSize: 12,
    }}>
      {state.status === "loading" ? "Atualizando…" : !onRetry ? SCOPED_LOAD_FAILURE
        : <button type="button" aria-label="Atualizar dados" onClick={onRetry}
          style={{ border:0, padding:0, background:"none", color:"inherit", cursor:"pointer" }}>
          {SCOPED_LOAD_FAILURE}
        </button>}
    </section>
  );
}
